
(function() {
  var result = { translations: { "en": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Actions" }, "tag": { "remove": "Remove tag" }, "Select": { "noResults": "No results found", "searchPlaceholder": "Search...", "clearSelections": "Clear selections" }, "ErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." }, "sessionId": { "prefix": "Session Id: " } }, "ProgressSteps": { "completedStep": "Completed step", "incompleteStep": "Incomplete step" }, "Paginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "Datagrid": { "noData": { "Title": "No data available", "Description": "There is no data available to display." }, "noResults": { "Title": "No results found", "Description": "Try adjusting your search and filters to find what you're looking for.", "ClearActionLabel": "Clear search and filters" }, "toolbar": { "selectedRows": { "one": "{{count}} row selected", "other": "{{count}} rows selected", "clearSelection": "Clear selection", "selectAll": "Select all {{totalRows}} rows" }, "search": { "placeholder": "Search", "label": "Search", "clearSearch": "Clear search" } }, "pagination": { "visibleRows": "{{visibleRows}} of {{totalRows}} results", "itemsPerPage": "Items per page", "countPerPage": { "one": "{{count}} per page", "other": "{{count}} per page" } }, "SkeletonGrid": { "loading": "Loading" }, "DataGridColumnManagementPanel": { "description": "Choose which properties to display as columns. Then, move properties up or down, or drag and drop, to change the order they will be displayed.", "removeAllColumns": "Remove all columns", "update": "Update", "cancel": "Cancel", "edit": "Edit columns" } } }, "ui": { "UIAbstractPageSection": { "page": "Page Section" }, "UICarousel": { "current": "Showing item {{currentStepDisplayNumber}} out of {{totalSteps}}", "prev": "Previous", "next": "Next", "tip": "Use arrow keys to see other items" }, "UIColorSwatch": { "label": "Color picker {{value}}", "noColorLabel": "Color picker, no color selected." }, "UIButtonCollapser": { "dropdownLabel": "Actions" }, "UIErrorMessage": { "error": { "title": "All is not lost." }, "notFound": { "title": "All who wander are not lost." }, "badRequest": { "title": "There was a problem loading this page." }, "expired": { "title": "We're sorry." } }, "UIPanelNavigator": { "backButton": "Go to previous screen" }, "UILoadingSpinner": { "busyText": "Loading", "completedText": "Loaded" }, "UISideNav": { "navigationLandmark": "Secondary" }, "UISortTH": { "ascendingSort": "Ascending sort. Press to sort descending.", "descendingSort": "Descending sort. Press to sort ascending.", "pressToSort": "Press to sort." }, "autosizedTextInput": { "charactersRemaining": "{{value}} characters remaining" }, "time": { "today": "Today at {{time}}", "yesterday": "Yesterday at {{time}}", "datetime": "{{date}} at {{time}}" }, "progress": { "percentComplete": "{{percent}} complete" }, "datePicker": { "dateSelected": "{{date}} is selected.", "noDateSelected": "No date selected.", "dateBelowMin": "You must choose a newer date", "dateAboveMax": "You must choose an older date", "invalidDate": "Invalid date", "today": "Today", "clear": "Clear", "placeholder": { "month": "MM", "day": "DD", "year": "YYYY" }, "nextMonth": "Next month", "prevMonth": "Previous month" }, "dateRange": { "startDate": "Start date", "endDate": "End date", "endDateBeforeStartDate": "The end date must come after the start date.", "startDateAfterEndDate": "The start date must come before the end date.", "to": "to" }, "timePicker": { "placeholder": { "hour": "HH", "minute": "MM" } }, "SelectResultList": { "andMore": "\u2026and {{count}} more.", "loadMore": "Load more" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Add" }, "UIAvatarHoverlay": { "text": "Change photo" }, "UIChangeArrow": { "decrease": "Decrease of ", "increase": "Increase of " }, "UICopyInput": { "label": "Copy", "title": "Copy to clipboard", "tooltipCopied": "Copied" }, "UIConfirm": { "defaultConfirm": "Yes", "defaultReject": "No" }, "UICloseButton": { "label": "Close" }, "UIDateRangePicker": { "rangeType": { "ALL": "All time", "THIS_DAY": "Today", "LAST_DAY": "Yesterday", "THIS_WEEK": "This week", "LAST_WEEK": "Last week", "THIS_MONTH": "This month", "LAST_MONTH": "Last month", "LAST_THIRTY_DAYS": "Last 30 days", "LAST_THREE_MONTHS": "Last 3 months", "THIS_QUARTER": "This quarter", "LAST_QUARTER": "Last quarter", "THIS_YEAR": "This year", "LAST_YEAR": "Last year", "CUSTOM": "Custom time period" } }, "UIDropdownSelect": { "placeholder": "No value selected" }, "UIEditableControls": { "cancel": "Cancel", "save": "Save" }, "UIExpandableText": { "collapseButtonText": "See less", "expandButtonText": "See more" }, "UIFileInput": { "defaultChangeLabel": "Change file", "defaultSelectLabel": "Choose file" }, "UIIconRating": { "ariaValueText": "{{value}} of {{maxValue}}" }, "UILink": { "externalTitle": "Link opens in a new window" }, "UILoading": { "title": "Loading\u2026" }, "UILockBadge": { "title": "This feature is locked" }, "UIPaginator": { "label": "Pagination", "pageNumber": { "currentIndicator": "You are currently on ", "description": "Page " }, "firstPage": { "label": "First", "description": "First page" }, "previousPage": { "label": "Prev", "description": "Previous page" }, "nextPage": { "label": "Next", "description": "Next page" }, "lastPage": { "label": "Last", "description": "Last page" } }, "UIPreviousButton": { "label": "Previous" }, "UINextButton": { "label": "Next" }, "UINumberRating": { "lowRangeLabel": "Strongly disagree", "highRangeLabel": "Strongly agree" }, "UISearchableSelectInput": { "placeholder": "Search" }, "UISearchInput": { "placeholder": "Search", "minimumSearchMessage": { "one": "Type 1 more character", "other": "Type {{count}} more characters" }, "clearButton": "Clear input" }, "UISelect": { "allOptionsSelected": "All options are selected", "createOption": "Create option \u201C{{label}}\u201D", "plusMore": "+ {{count}} more", "andMore": "\u2026and {{count}} more.", "loadMore": "Load more", "noResults": "No results found", "placeholder": "Search", "typeToSearch": "Type to search" }, "UITable": { "selectableTableRow": { "toggleSelection": "Toggle selection of the row" } }, "UITabs": { "moreDropdownLabel": "More" }, "UITeaseNotification": { "optionsButtonTooltipText": "Show options" }, "UITimePicker": { "placeholder": "Select a time" }, "UIToggle": { "checkedLabel": "ON", "uncheckedLabel": "OFF" }, "UITypeahead": { "noMatchesFound": "No matches found", "noOptions": "None" }, "UIWizard": { "back": "Back", "cancel": "Cancel", "done": "Done", "next": "Next", "stepCount": "Step {{stepNumber}} of {{stepCount}}" }, "XSSTooltip": { "explanation": "This link has been disabled for your security." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "en": "static-1.5379"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.5379",
    "ar-eg": "static-1.5379",
    "bg": "static-1.5379",
    "bn": "static-1.5379",
    "ca-es": "static-1.5379",
    "cs": "static-1.5379",
    "da": "static-1.5379",
    "de": "static-1.5379",
    "el": "static-1.5379",
    "en-gb": "static-1.5379",
    "en": "static-1.5379",
    "es-mx": "static-1.5379",
    "es": "static-1.5379",
    "et": "static-1.5379",
    "fi": "static-1.5379",
    "fr-ca": "static-1.5379",
    "fr": "static-1.5379",
    "he-il": "static-1.5379",
    "hi": "static-1.5379",
    "hr": "static-1.5379",
    "hu": "static-1.5379",
    "id": "static-1.5379",
    "it": "static-1.5379",
    "ja": "static-1.5379",
    "ko": "static-1.5379",
    "lt": "static-1.5379",
    "ms": "static-1.5379",
    "nl": "static-1.5379",
    "no": "static-1.5379",
    "pl": "static-1.5379",
    "pt-br": "static-1.5379",
    "pt-pt": "static-1.5379",
    "ro": "static-1.5379",
    "ru": "static-1.5379",
    "sk": "static-1.5379",
    "sl": "static-1.5379",
    "sv": "static-1.5379",
    "th": "static-1.5379",
    "tl": "static-1.5379",
    "tr": "static-1.5379",
    "uk": "static-1.5379",
    "vi": "static-1.5379",
    "zh-cn": "static-1.5379",
    "zh-hk": "static-1.5379",
    "zh-tw": "static-1.5379"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:en', {version: 'static-1.5379'}); }
})();



(function() {
  var result = { translations: { "en": { "placeholder": "placeholder" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "en": "static-3.6731"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.6731",
    "ar-eg": "static-3.6731",
    "bg": "static-3.6731",
    "bn": "static-3.6731",
    "ca-es": "static-3.6731",
    "cs": "static-3.6731",
    "da": "static-3.6731",
    "de": "static-3.6731",
    "el": "static-3.6731",
    "en-gb": "static-3.6731",
    "en": "static-3.6731",
    "es-mx": "static-3.6731",
    "es": "static-3.6731",
    "et": "static-3.6731",
    "fi": "static-3.6731",
    "fr-ca": "static-3.6731",
    "fr": "static-3.6731",
    "he-il": "static-3.6731",
    "hi": "static-3.6731",
    "hr": "static-3.6731",
    "hu": "static-3.6731",
    "id": "static-3.6731",
    "it": "static-3.6731",
    "ja": "static-3.6731",
    "ko": "static-3.6731",
    "lt": "static-3.6731",
    "ms": "static-3.6731",
    "nl": "static-3.6731",
    "no": "static-3.6731",
    "pl": "static-3.6731",
    "pt-br": "static-3.6731",
    "pt-pt": "static-3.6731",
    "ro": "static-3.6731",
    "ru": "static-3.6731",
    "sk": "static-3.6731",
    "sl": "static-3.6731",
    "sv": "static-3.6731",
    "th": "static-3.6731",
    "tl": "static-3.6731",
    "tr": "static-3.6731",
    "uk": "static-3.6731",
    "vi": "static-3.6731",
    "zh-cn": "static-3.6731",
    "zh-hk": "static-3.6731",
    "zh-tw": "static-3.6731"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:en', {version: 'static-3.6731'}); }
})();



(function() {
  var result = { translations: { "en": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} of {{totalBytes}}" }, "fileSizeLimit": "The file can't be larger than {{size}}" } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "af": "static-1.18438",
    "ar-eg": "static-1.18438",
    "bg": "static-1.18438",
    "bn": "static-1.18438",
    "ca-es": "static-1.18438",
    "cs": "static-1.18438",
    "da": "static-1.18438",
    "de": "static-1.18438",
    "el": "static-1.18438",
    "en-gb": "static-1.18438",
    "en": "static-1.18438",
    "es-mx": "static-1.18438",
    "es": "static-1.18438",
    "et": "static-1.18438",
    "fi": "static-1.18438",
    "fr-ca": "static-1.18438",
    "fr": "static-1.18438",
    "he-il": "static-1.18438",
    "hi": "static-1.18438",
    "hr": "static-1.18438",
    "hu": "static-1.18438",
    "id": "static-1.18438",
    "it": "static-1.18438",
    "ja": "static-1.18438",
    "ko": "static-1.18438",
    "lt": "static-1.18438",
    "ms": "static-1.18438",
    "nl": "static-1.18438",
    "no": "static-1.18438",
    "pl": "static-1.18438",
    "pt-br": "static-1.18438",
    "pt-pt": "static-1.18438",
    "ro": "static-1.18438",
    "ru": "static-1.18438",
    "sk": "static-1.18438",
    "sl": "static-1.18438",
    "sv": "static-1.18438",
    "th": "static-1.18438",
    "tl": "static-1.18438",
    "tr": "static-1.18438",
    "uk": "static-1.18438",
    "vi": "static-1.18438",
    "zh-cn": "static-1.18438",
    "zh-hk": "static-1.18438",
    "zh-tw": "static-1.18438"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "en": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "There was a network connection issue.", "message": "Please check your connection and try again.", "button": "Try again" } } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "af": "static-1.18438",
    "ar-eg": "static-1.18438",
    "bg": "static-1.18438",
    "bn": "static-1.18438",
    "ca-es": "static-1.18438",
    "cs": "static-1.18438",
    "da": "static-1.18438",
    "de": "static-1.18438",
    "el": "static-1.18438",
    "en-gb": "static-1.18438",
    "en": "static-1.18438",
    "es-mx": "static-1.18438",
    "es": "static-1.18438",
    "et": "static-1.18438",
    "fi": "static-1.18438",
    "fr-ca": "static-1.18438",
    "fr": "static-1.18438",
    "he-il": "static-1.18438",
    "hi": "static-1.18438",
    "hr": "static-1.18438",
    "hu": "static-1.18438",
    "id": "static-1.18438",
    "it": "static-1.18438",
    "ja": "static-1.18438",
    "ko": "static-1.18438",
    "lt": "static-1.18438",
    "ms": "static-1.18438",
    "nl": "static-1.18438",
    "no": "static-1.18438",
    "pl": "static-1.18438",
    "pt-br": "static-1.18438",
    "pt-pt": "static-1.18438",
    "ro": "static-1.18438",
    "ru": "static-1.18438",
    "sk": "static-1.18438",
    "sl": "static-1.18438",
    "sv": "static-1.18438",
    "th": "static-1.18438",
    "tl": "static-1.18438",
    "tr": "static-1.18438",
    "uk": "static-1.18438",
    "vi": "static-1.18438",
    "zh-cn": "static-1.18438",
    "zh-hk": "static-1.18438",
    "zh-tw": "static-1.18438"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "en": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Sorry, we couldn't verify your email address." } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "af": "static-1.18438",
    "ar-eg": "static-1.18438",
    "bg": "static-1.18438",
    "bn": "static-1.18438",
    "ca-es": "static-1.18438",
    "cs": "static-1.18438",
    "da": "static-1.18438",
    "de": "static-1.18438",
    "el": "static-1.18438",
    "en-gb": "static-1.18438",
    "en": "static-1.18438",
    "es-mx": "static-1.18438",
    "es": "static-1.18438",
    "et": "static-1.18438",
    "fi": "static-1.18438",
    "fr-ca": "static-1.18438",
    "fr": "static-1.18438",
    "he-il": "static-1.18438",
    "hi": "static-1.18438",
    "hr": "static-1.18438",
    "hu": "static-1.18438",
    "id": "static-1.18438",
    "it": "static-1.18438",
    "ja": "static-1.18438",
    "ko": "static-1.18438",
    "lt": "static-1.18438",
    "ms": "static-1.18438",
    "nl": "static-1.18438",
    "no": "static-1.18438",
    "pl": "static-1.18438",
    "pt-br": "static-1.18438",
    "pt-pt": "static-1.18438",
    "ro": "static-1.18438",
    "ru": "static-1.18438",
    "sk": "static-1.18438",
    "sl": "static-1.18438",
    "sv": "static-1.18438",
    "th": "static-1.18438",
    "tl": "static-1.18438",
    "tr": "static-1.18438",
    "uk": "static-1.18438",
    "vi": "static-1.18438",
    "zh-cn": "static-1.18438",
    "zh-hk": "static-1.18438",
    "zh-tw": "static-1.18438"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "en": { "conversations-visitor-experience-components": { "visitorWidget": { "header": { "threadListTitle": "Your Chats" }, "threadListCard": { "YourChats": "Your Chats", "YourChatsV2": "Chat History", "oneDayAgo": "One Day ago" }, "navigation": { "kbNavigation": "knowledge base navigation tabs", "options": { "chat": "Chat", "help": "Help" } } } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "af": "static-1.18438",
    "ar-eg": "static-1.18438",
    "bg": "static-1.18438",
    "bn": "static-1.18438",
    "ca-es": "static-1.18438",
    "cs": "static-1.18438",
    "da": "static-1.18438",
    "de": "static-1.18438",
    "el": "static-1.18438",
    "en-gb": "static-1.18438",
    "en": "static-1.18438",
    "es-mx": "static-1.18438",
    "es": "static-1.18438",
    "et": "static-1.18438",
    "fi": "static-1.18438",
    "fr-ca": "static-1.18438",
    "fr": "static-1.18438",
    "he-il": "static-1.18438",
    "hi": "static-1.18438",
    "hr": "static-1.18438",
    "hu": "static-1.18438",
    "id": "static-1.18438",
    "it": "static-1.18438",
    "ja": "static-1.18438",
    "ko": "static-1.18438",
    "lt": "static-1.18438",
    "ms": "static-1.18438",
    "nl": "static-1.18438",
    "no": "static-1.18438",
    "pl": "static-1.18438",
    "pt-br": "static-1.18438",
    "pt-pt": "static-1.18438",
    "ro": "static-1.18438",
    "ru": "static-1.18438",
    "sk": "static-1.18438",
    "sl": "static-1.18438",
    "sv": "static-1.18438",
    "th": "static-1.18438",
    "tl": "static-1.18438",
    "tr": "static-1.18438",
    "uk": "static-1.18438",
    "vi": "static-1.18438",
    "zh-cn": "static-1.18438",
    "zh-hk": "static-1.18438",
    "zh-tw": "static-1.18438"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "en": { "helpWidgetComponents": { "knowledgeBaseSearch": { "header": "Find answers quickly", "seeMoreResults": "See more results", "searchLabel": "Search knowledge base articles", "searchPlaceholder": "Search articles", "clearSearch": "Clear search", "noResultsForTerm": "No results for <strong>\"{{ searchTerm }}\"</strong>.<br/> Try another search term.", "didntFindResults": "Didn't find what you were looking for?", "goToKnowledgeBase": "Go to knowledge base", "announceSearchResults": "{{resultsCount}} results available for {{searchTerm}}", "announceEmptySearchResults": "No results available for {{searchTerm}}. Try another search term. Didn't find what you are looking for? Navigate to the Go to knowledge base link to search answers." } }, "conversations-visitor-experience-components": { "install-code-step": { "description": "<p>Copy the code below and paste it into every page you\u2019d like chat to appear on. When you\u2019re adding the code, make sure it\u2019s placed just before the end of the &lt;body&gt; tag. You can also add it to your site footer.</p><p>If you\u2019re a Marketing customer using the HubSpot CMS, you don't need to do anything. Your tracking code is automatically installed on all HubSpot-hosted pages.</p>", "howToLink": "How do I add the code?", "copyButton": "Copy", "installCodeEmailForm": { "title": "Need someone else to install the code?", "description": "Email the code snippet to your web developer or admin.", "placeholder": "Enter email address", "error": "Please enter a valid email address.", "send": "Send" } }, "officeHours": { "defaultMessageText": "We'll return tomorrow at 9:00 AM", "sameDay": "We'll return today at {{time}}", "nextDay": "We'll return tomorrow at {{time}}", "nextWeek": "We'll return {{dayOfWeek}} at {{time}}" }, "alerts": { "pubNubStatus": { "visiblyOffline": { "title": "Sorry. There was an issue connecting to the network. ", "description": "Please wait a few seconds and try again." }, "PNNetworkUpCategory": { "title": "The network connection issue is resolved.", "description": "Success! You're connected to messages again." }, "PNRsubscribeLimitReached": { "title": "Sorry. We can't connect you to messages right now.", "description": "Please refresh your page." } } }, "errorAlert": { "titleText": "Something went wrong.", "message_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Please try again. If it keeps happening, ", createElement( options, "Link", { onClick: props.onClick }, "let us know" ), "." ); }, "eventId": "Event Id: {{ eventId }}" }, "unknownVisitor": "Unknown visitor", "isResponderAI": "Powered by AI", "notifications": { "unknownVisitor": "Unknown visitor", "title": { "withIdentity": "{{ identifier }} | HubSpot Messages" }, "newMessage": "New live chat from {{ identifier }}", "newEmail": "New email from {{ identifier }}", "assignment": "{{ identifier }} assigned a conversation to you.", "pushText": "A visitor has sent you a new message." }, "buttons": { "agree": "I agree", "disagree": "Decline for now", "submit": "Submit" }, "visitorExperienceAriaLabels": { "dismiss": "Dismiss", "drag": "Drag", "open": "Open live chat", "close": "Close live chat", "attachment": "attach a file", "send": "send message", "showThreadList": "View thread list, {{ unreadThreadCount }} unread threads", "createNewThread": "Create new thread", "badgeDescription": "New notifications", "welcomeMessage": "Welcome message", "liveChat": "Live Chat", "sdkClickToCloseWidget": "Click to close widget" }, "chatTextArea": { "validationMessage": "Message is too long.", "placeholder": "Write a message" }, "welcomeMessageTextArea": { "validationMessage": "Message is too long.", "placeholder": "Write a message...", "tooltip": "Ask me something", "close": "Close" }, "newThreadPrompt": { "chatMovedToEmail": "Chat has been moved to email." }, "botAwayMessage": { "heading": "Our team isn't online at the moment.", "paragraph": "We'll be back during our business hours and look forward to chatting with you then." }, "default": { "repText": "Hi there! Let me know if you have any questions about the product or pricing.", "initialMessage": "Got any questions? I'm happy to help.", "askForEmailMessage": "Don\u2019t have time to wait for a response? Leave your email and we\u2019ll be in touch as soon as possible.", "knowledgeBaseHeaderText": "Help", "agent": "Agent", "aiAgent": "Powered by AI", "avatar": "Avatar of {{ identifier }}", "avatarAvailable": "Avatar of {{ identifier }}; agent is available for chat", "avatarAway": "Avatar of {{ identifier }}; agent is away" }, "dateStringWithOn": "on {{ dateString }}", "quickReply": { "selectionPlaceholder": "Select one", "selectionComplete": "Send" }, "gdpr": { "consentToCookies": { "pageLoadCookieConsent": "This chat widget uses a cookie to interact with website visitors and to provide your chat history. To find out more about this cookie, see our <a target='_blank' href=\"https://legal.hubspot.com/privacy-policy\" rel='noopener'>Privacy Policy</a>." } }, "knowledgeBase": { "kbHeaderText": "Help", "threadListHeaderText": "Chat", "articleCategories": { "title": "Browse Categories", "article": "article", "articles": "articles" }, "mostViewed": { "title": "Trending Articles" }, "highestRated": { "title": "Highest Rated Articles" }, "kbArticle": { "backToChat": "Back to chat", "backToKB": "Back to Knowledge Base", "expand": "Expand", "collapse": "Collapse", "openInNewTab": "Open article in new tab" }, "articleNames": { "howToSetupYourAccount": "How to setup your account", "managingYourSubscriptionPlan": "Managing your subscription plan", "dataPrivacyAndSecurity": "Data privacy and security" }, "categoryNames": { "gettingStarted": "Getting Started", "accountAndBilling": "Account & Billing", "troubleshootingAndFaqs": "Troubleshooting & FAQs" } } } } } };
  result.translationsLoaded = {
  "conversations-visitor-experience-components": {
    "en": "static-1.18438"
  }
};
  result.translationsAvailable = {
  "conversations-visitor-experience-components": {
    "af": "static-1.18438",
    "ar-eg": "static-1.18438",
    "bg": "static-1.18438",
    "bn": "static-1.18438",
    "ca-es": "static-1.18438",
    "cs": "static-1.18438",
    "da": "static-1.18438",
    "de": "static-1.18438",
    "el": "static-1.18438",
    "en-gb": "static-1.18438",
    "en": "static-1.18438",
    "es-mx": "static-1.18438",
    "es": "static-1.18438",
    "et": "static-1.18438",
    "fi": "static-1.18438",
    "fr-ca": "static-1.18438",
    "fr": "static-1.18438",
    "he-il": "static-1.18438",
    "hi": "static-1.18438",
    "hr": "static-1.18438",
    "hu": "static-1.18438",
    "id": "static-1.18438",
    "it": "static-1.18438",
    "ja": "static-1.18438",
    "ko": "static-1.18438",
    "lt": "static-1.18438",
    "ms": "static-1.18438",
    "nl": "static-1.18438",
    "no": "static-1.18438",
    "pl": "static-1.18438",
    "pt-br": "static-1.18438",
    "pt-pt": "static-1.18438",
    "ro": "static-1.18438",
    "ru": "static-1.18438",
    "sk": "static-1.18438",
    "sl": "static-1.18438",
    "sv": "static-1.18438",
    "th": "static-1.18438",
    "tl": "static-1.18438",
    "tr": "static-1.18438",
    "uk": "static-1.18438",
    "vi": "static-1.18438",
    "zh-cn": "static-1.18438",
    "zh-hk": "static-1.18438",
    "zh-tw": "static-1.18438"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-visitor-experience-components:en', {version: 'static-1.18438'}); }
})();



(function() {
  var result = { translations: { "en": { "conversations-visitor-message-history": { "sources": "Sources", "generatingMessage": "Generating response...", "email-capture": { "thanks": "Thank you for your email. We'll be in touch as soon as possible.", "invalid": "You entered an invalid email.", "failed": "Sorry, we couldn't verify your email address.", "placeholderText": "Enter email address", "consentToCommunicate": "I agree to receive other communications from {{ accountName }}", "submitEmailAddress": "Submit email address" }, "initial-message": { "header": "Welcome message", "headerTooltip": "A welcome message is a prompt used to invite your website visitors to start a conversation." }, "common-message": { "hiddenMessage": "This message is hidden." }, "status": { "publishing": { "UNPUBLISHED": "Sending... ", "PUBLISH_FAILED": "Not delivered. Click to retry." } }, "quickReply": { "selectionPlaceholder": "Select one", "selectionComplete": "Done" }, "agentSays": "Agent says:", "subjectSays": "{{ subject }} says:", "iSay": "I say:", "subjectIsTyping": "{{ subject }} is typing", "typingMessage": "Typing...", "thinkingMessage": "Thinking...", "systemMessage": "System message:", "agent": "Agent", "bot": "Bot", "system": "System", "avatar": "Avatar of {{ identifier }}" } } } };
  result.translationsLoaded = {
  "conversations-visitor-message-history": {
    "en": "static-1.17175"
  }
};
  result.translationsAvailable = {
  "conversations-visitor-message-history": {
    "af": "static-1.17175",
    "ar-eg": "static-1.17175",
    "bg": "static-1.17175",
    "bn": "static-1.17175",
    "ca-es": "static-1.17175",
    "cs": "static-1.17175",
    "da": "static-1.17175",
    "de": "static-1.17175",
    "el": "static-1.17175",
    "en-gb": "static-1.17175",
    "en": "static-1.17175",
    "es-mx": "static-1.17175",
    "es": "static-1.17175",
    "et": "static-1.17175",
    "fi": "static-1.17175",
    "fr-ca": "static-1.17175",
    "fr": "static-1.17175",
    "he-il": "static-1.17175",
    "hi": "static-1.17175",
    "hr": "static-1.17175",
    "hu": "static-1.17175",
    "id": "static-1.17175",
    "it": "static-1.17175",
    "ja": "static-1.17175",
    "ko": "static-1.17175",
    "lt": "static-1.17175",
    "ms": "static-1.17175",
    "nl": "static-1.17175",
    "no": "static-1.17175",
    "pl": "static-1.17175",
    "pt-br": "static-1.17175",
    "pt-pt": "static-1.17175",
    "ro": "static-1.17175",
    "ru": "static-1.17175",
    "sk": "static-1.17175",
    "sl": "static-1.17175",
    "sv": "static-1.17175",
    "th": "static-1.17175",
    "tl": "static-1.17175",
    "tr": "static-1.17175",
    "uk": "static-1.17175",
    "vi": "static-1.17175",
    "zh-cn": "static-1.17175",
    "zh-hk": "static-1.17175",
    "zh-tw": "static-1.17175"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-visitor-message-history:en', {version: 'static-1.17175'}); }
})();



(function() {
  var result = { translations: { "en": { "conversations-message-history": { "responder": { "automatic": "Automated", "bot": "Bot", "unknownResponder": "Unknown user", "unknownSender": "Unknown sender", "unknownVisitor": "Unknown visitor", "unknownVisitorAvatar": "Unknown Visitor" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "af": "static-1.9319",
    "ar-eg": "static-1.9319",
    "bg": "static-1.9319",
    "bn": "static-1.9319",
    "ca-es": "static-1.9319",
    "cs": "static-1.9319",
    "da": "static-1.9319",
    "de": "static-1.9319",
    "el": "static-1.9319",
    "en-gb": "static-1.9319",
    "en": "static-1.9319",
    "es-mx": "static-1.9319",
    "es": "static-1.9319",
    "et": "static-1.9319",
    "fi": "static-1.9319",
    "fr-ca": "static-1.9319",
    "fr": "static-1.9319",
    "he-il": "static-1.9319",
    "hi": "static-1.9319",
    "hr": "static-1.9319",
    "hu": "static-1.9319",
    "id": "static-1.9319",
    "it": "static-1.9319",
    "ja": "static-1.9319",
    "ko": "static-1.9319",
    "lt": "static-1.9319",
    "ms": "static-1.9319",
    "nl": "static-1.9319",
    "no": "static-1.9319",
    "pl": "static-1.9319",
    "pt-br": "static-1.9319",
    "pt-pt": "static-1.9319",
    "ro": "static-1.9319",
    "ru": "static-1.9319",
    "sk": "static-1.9319",
    "sl": "static-1.9319",
    "sv": "static-1.9319",
    "th": "static-1.9319",
    "tl": "static-1.9319",
    "tr": "static-1.9319",
    "uk": "static-1.9319",
    "vi": "static-1.9319",
    "zh-cn": "static-1.9319",
    "zh-hk": "static-1.9319",
    "zh-tw": "static-1.9319"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "en": { "conversations-message-history": { "status": { "closed": "This thread was closed on {{ dateString }}", "restore": "Restore this message", "publishing": { "UNPUBLISHED": "Sending... ", "PUBLISH_FAILED": "Not delivered. Click to retry." } } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "conversations-message-history": {
    "af": "static-1.9319",
    "ar-eg": "static-1.9319",
    "bg": "static-1.9319",
    "bn": "static-1.9319",
    "ca-es": "static-1.9319",
    "cs": "static-1.9319",
    "da": "static-1.9319",
    "de": "static-1.9319",
    "el": "static-1.9319",
    "en-gb": "static-1.9319",
    "en": "static-1.9319",
    "es-mx": "static-1.9319",
    "es": "static-1.9319",
    "et": "static-1.9319",
    "fi": "static-1.9319",
    "fr-ca": "static-1.9319",
    "fr": "static-1.9319",
    "he-il": "static-1.9319",
    "hi": "static-1.9319",
    "hr": "static-1.9319",
    "hu": "static-1.9319",
    "id": "static-1.9319",
    "it": "static-1.9319",
    "ja": "static-1.9319",
    "ko": "static-1.9319",
    "lt": "static-1.9319",
    "ms": "static-1.9319",
    "nl": "static-1.9319",
    "no": "static-1.9319",
    "pl": "static-1.9319",
    "pt-br": "static-1.9319",
    "pt-pt": "static-1.9319",
    "ro": "static-1.9319",
    "ru": "static-1.9319",
    "sk": "static-1.9319",
    "sl": "static-1.9319",
    "sv": "static-1.9319",
    "th": "static-1.9319",
    "tl": "static-1.9319",
    "tr": "static-1.9319",
    "uk": "static-1.9319",
    "vi": "static-1.9319",
    "zh-cn": "static-1.9319",
    "zh-hk": "static-1.9319",
    "zh-tw": "static-1.9319"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "en": { "conversations-message-history": { "noContent": "This message has no content", "default": { "repText": "Hi there! Let me know if you have any questions about the product or pricing.", "visitorText": "Can you go into a bit more detail about your pricing structure?" }, "friendlyNames": { "DEFAULT_UNKNOWN": "Unknown", "DEFAULT_AGENT": "Unknown agent", "DEFAULT_CUSTOMER": "Unknown visitor", "DEFAULT_INTEGRATOR": "Unknown integrator", "DEFAULT_AUTOMATED": "Automated", "DEFAULT_EXTERNAL": "Unknown external user", "DEFAULT_LLM": "AI Chatbot", "maybeName": "Maybe: {{name}}" } } } } };
  result.translationsLoaded = {
  "conversations-message-history": {
    "en": "static-1.9319"
  }
};
  result.translationsAvailable = {
  "conversations-message-history": {
    "af": "static-1.9319",
    "ar-eg": "static-1.9319",
    "bg": "static-1.9319",
    "bn": "static-1.9319",
    "ca-es": "static-1.9319",
    "cs": "static-1.9319",
    "da": "static-1.9319",
    "de": "static-1.9319",
    "el": "static-1.9319",
    "en-gb": "static-1.9319",
    "en": "static-1.9319",
    "es-mx": "static-1.9319",
    "es": "static-1.9319",
    "et": "static-1.9319",
    "fi": "static-1.9319",
    "fr-ca": "static-1.9319",
    "fr": "static-1.9319",
    "he-il": "static-1.9319",
    "hi": "static-1.9319",
    "hr": "static-1.9319",
    "hu": "static-1.9319",
    "id": "static-1.9319",
    "it": "static-1.9319",
    "ja": "static-1.9319",
    "ko": "static-1.9319",
    "lt": "static-1.9319",
    "ms": "static-1.9319",
    "nl": "static-1.9319",
    "no": "static-1.9319",
    "pl": "static-1.9319",
    "pt-br": "static-1.9319",
    "pt-pt": "static-1.9319",
    "ro": "static-1.9319",
    "ru": "static-1.9319",
    "sk": "static-1.9319",
    "sl": "static-1.9319",
    "sv": "static-1.9319",
    "th": "static-1.9319",
    "tl": "static-1.9319",
    "tr": "static-1.9319",
    "uk": "static-1.9319",
    "vi": "static-1.9319",
    "zh-cn": "static-1.9319",
    "zh-hk": "static-1.9319",
    "zh-tw": "static-1.9319"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:conversations-message-history:en', {version: 'static-1.9319'}); }
})();



(function() {
  var result = { translations: { "en": { "sanitizedEmail": { "imageError": "This image is too large to display.", "expandEmailButtonText": "Expand", "collapseEmailButtonText": "Collapse", "hideEmailRepliesButtonText": "Hide trimmed content", "showEmailRepliesButtonText": "View trimmed content" } } } };
  result.translationsLoaded = {
  "sanitize-text": {
    "en": "static-1.6472"
  }
};
  result.translationsAvailable = {
  "sanitize-text": {
    "af": "static-1.6472",
    "ar-eg": "static-1.6472",
    "bg": "static-1.6472",
    "bn": "static-1.6472",
    "ca-es": "static-1.6472",
    "cs": "static-1.6472",
    "da": "static-1.6472",
    "de": "static-1.6472",
    "el": "static-1.6472",
    "en-gb": "static-1.6472",
    "en": "static-1.6472",
    "es-mx": "static-1.6472",
    "es": "static-1.6472",
    "et": "static-1.6472",
    "fi": "static-1.6472",
    "fr-ca": "static-1.6472",
    "fr": "static-1.6472",
    "he-il": "static-1.6472",
    "hi": "static-1.6472",
    "hr": "static-1.6472",
    "hu": "static-1.6472",
    "id": "static-1.6472",
    "it": "static-1.6472",
    "ja": "static-1.6472",
    "ko": "static-1.6472",
    "lt": "static-1.6472",
    "ms": "static-1.6472",
    "nl": "static-1.6472",
    "no": "static-1.6472",
    "pl": "static-1.6472",
    "pt-br": "static-1.6472",
    "pt-pt": "static-1.6472",
    "ro": "static-1.6472",
    "ru": "static-1.6472",
    "sk": "static-1.6472",
    "sl": "static-1.6472",
    "sv": "static-1.6472",
    "th": "static-1.6472",
    "tl": "static-1.6472",
    "tr": "static-1.6472",
    "uk": "static-1.6472",
    "vi": "static-1.6472",
    "zh-cn": "static-1.6472",
    "zh-hk": "static-1.6472",
    "zh-tw": "static-1.6472"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:sanitize-text:en', {version: 'static-1.6472'}); }
})();



(function() {
  var result = { translations: { "en": { "app": { "htmlTitle": "Live Chat Builder by HubSpot", "landingPage": { "title": "Create your free live chat", "subtitle": "Embed live chat to your website after customizing it to your business", "start": "Create live chat", "copyright": "Copyright \xA9 {{ year }} HubSpot, Inc.", "sample": { "name": "Johnny Appleseed", "responseTime": "We typically reply in a few minutes", "message1": "Got any questions? I'm happy to help.", "message2": "I have a question about your products and services", "message3": "What would you like to know?" } }, "chat": { "defaultAgentName": "Agent", "defaultDisplayName": "{{ agentName }} from {{ companyName }}", "defaultWelcomeMessage": "Got any questions? I'm here to help." }, "steps": { "stepCounter": "Step {{ current }} of 3", "back": "Back" }, "wizardHeading": "Create your free live chat", "firstStep": { "dayMode": { "title": "Your Details" }, "title": "Create free live chat for your website", "selectColor": "Select a color", "firstName": "First name", "firstNamePlaceholder": "John", "lastName": "Last name", "lastNamePlaceholder": "Smith", "companyName": "Company", "companyNamePlaceholder": "Acme", "companyDomain": "Company domain", "companyDomainPlaceholder": "HubSpot.com", "companyDomainTooltip": "This will enable us to display a preview of how the live chat will appear on your website.", "nextStep": "Next: Customize your Live Chat", "previewDescription": "Preview: Event details", "stepName": "Details" }, "secondStep": { "dayMode": { "title": "Customization" }, "title": "Customize your live chat", "chatHeading": "Chat heading", "chatHeadingPlaceholder": "John Smith from Acme", "chatHeadingTooltip": "Add a custom chat heading to give your chat a personalized touch.", "welcomeMessage": "Write a welcome message", "welcomeMessagePlaceholder": "Got any questions? I'm happy to help.", "welcomeMessageTooltip": "Visitors will see this message when they land on your site.", "nextStep": "Next: Style your live chat", "previewDescription": "Preview: Live Chat", "stepName": "Customization" }, "thirdStep": { "dayMode": { "title": "Display" }, "title": "Style your live chat", "colorPicker": "Select live chat color", "colorPickerTooltip": "When inputting a custom color, you may want to test it on your websites background to make sure that it meets accessibility standards.", "nextStep": "Next: Complete HubSpot Sign-up", "previewDescription": "Preview: Website", "stepName": "Display" }, "create": { "chatflowName": "New Chatflow", "askForEmailMessage": "Don\u2019t have time to wait for a response? Leave your email and we\u2019ll be in touch as soon as possible.", "initialMessage": "Got any questions? I'm happy to help.", "chatCreated": "Success! Your live chat has been created.", "clickHere": "Click here to view your live chat" }, "widget": { "initialMessage": "Got any questions? I'm here to help." }, "availabilityStep": { "title": "Set up when your Live Chat is available", "radio": { "teamOnline": "Available when the team is online", "businessHours": "Available during business hours", "always": "Always 24/7", "custom": "Custom" }, "nextStep": "Add free Live Chat to your website" }, "doneStep": { "title": "You're almost done, sign up to launch your website\u2019s live chat", "subtitle": "Sign up to HubSpot for free to complete the setup", "cta": "Sign up to get started" }, "wizard": { "heading": "Create live chat", "stepCounter": "Step {{ current }} of {{ total }}", "footer": { "next": { "start": { "nextStep": "Next: Customize your Live Chat", "nextStepMobile": "Next: Customization" }, "customize": { "nextStep": "Next: Style your live chat", "nextStepMobile": "Next: Style your live chat" }, "style": { "nextStep": "Next: Complete HubSpot Sign-up", "nextStepMobile": "Next: Save chat and Sign-up to HubSpot" } }, "done": "Done", "cancel": "Cancel" } } } } } };
  result.translationsLoaded = {
  "livechat-unboxing-ui": {
    "en": "static-1.6001"
  }
};
  result.translationsAvailable = {
  "livechat-unboxing-ui": {
    "da": "static-1.6001",
    "de": "static-1.6001",
    "en": "static-1.6001",
    "es": "static-1.6001",
    "fi": "static-1.6001",
    "fr": "static-1.6001",
    "it": "static-1.6001",
    "ja": "static-1.6001",
    "ko": "static-1.6001",
    "nl": "static-1.6001",
    "no": "static-1.6001",
    "pl": "static-1.6001",
    "pt-br": "static-1.6001",
    "sv": "static-1.6001",
    "th": "static-1.6001",
    "zh-cn": "static-1.6001",
    "zh-tw": "static-1.6001"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:livechat-unboxing-ui:en', {version: 'static-1.6001'}); }
})();


